module.exports = __webpack_public_path__ + "static/media/instructions-vimeo.d03af885.jpg";